import Mall from './component';

export default Mall;
